import React from "react";
import Flatpickr from "react-flatpickr";
import { Controller } from "react-hook-form";
import { Label } from "reactstrap";

const TimePicker = ({ label = "", name, control, errors }) => {
  const disableMinuteInputPlugin = fp => {
    return {
      onReady: function () {
        const minutesInput =
          fp.timeContainer.querySelector(".flatpickr-minute");
        if (minutesInput) {
          minutesInput.disabled = true;
        }
      },
      onDestroy: function () {
        const minutesInput =
          fp.timeContainer.querySelector(".flatpickr-minute");
        if (minutesInput) {
          minutesInput.disabled = true;
        }
      },
    };
  };

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Flatpickr
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: "H:i",
              minuteIncrement: 30,
              time_24hr: true,
              allowInput: false, // Disable direct input
              disableMobile: true,
              plugins: [disableMinuteInputPlugin],
            }}
            style={{
              width: "100%",
              boxSizing: "border-box",
              // fontSize: "17px",
              // border: "1px solid #74788d",
              // borderRadius: "6px",
              paddingLeft: "12px",
              cursor: "pointer",
            }}
            className={`form-control ${errors[name] && `is-invalid`}`}
            {...field}
          />
        )}
      />
      {/* {errors[name] && <MessageFormValidate error={errors[name].message} />} */}
    </div>
  );
};

export default TimePicker;
